// store/action.js
import * as types from './types'

export default {
  // rest state action
  resetStates: function(context, payLoad) {
    context.commit(types.RESET_STATES, payLoad)
  }
}
